module.exports = __webpack_public_path__ + "img/Interdenominasi-logo.de493dbf.png";